import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data?.session_token) localStorage.setItem("session_token", data.session_token);
        if (data?.user) setUser(data.user);
        // Clean URL
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        console.error("Google OAuth callback failed:", err);
        const detail = err?.response?.data?.detail;
        const status = err?.response?.status;
        const msg = typeof detail === "string"
          ? detail
          : `Échec de la connexion Google${status ? ` (HTTP ${status})` : ""}. ${err?.message || ""}`;
        setError(msg);
      }
    })();
  }, [navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md w-full ra-card p-6 text-center">
          <p className="overline text-red-600">Échec de la connexion Google</p>
          <h1 className="font-heading font-black text-2xl tracking-tight mt-2 mb-3">Connexion impossible</h1>
          <p className="text-sm text-gray-600 mb-4 break-words">{error}</p>
          <Link to="/login" className="btn-primary w-full justify-center">Retour à la connexion</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="max-w-sm w-full">
        <div className="progress-line mb-4" />
        <p className="overline text-center">Connexion en cours...</p>
      </div>
    </div>
  );
}
